import {BaseContainerModel} from '../../base-container.model';
import {wf_issue_sprint_hdr_RowClass, wf_issue_sprint_hdr_RowInterface} from '../../../dbschema/wf_issue_sprint_hdr.model';

export class WfIssueSprintContainerModel extends BaseContainerModel {
  wf_issue_sprint_hdr: wf_issue_sprint_hdr_RowInterface = new wf_issue_sprint_hdr_RowClass();
}
